<script lang="ts" setup>
    import {PageTitle} from '../../LibMain';
    import {CssLength } from "../../lib/CssHelpers"
    import {IReceiptData} from '../../lib/Models/PaySimpleCreditCardModel';  
    import PaySimpleCreditCard from "./PaySimpleCreditCard.vue"; 
    import MessageSection from "../../components/Messages/MessageSection.vue";
    import { MessageSectionType, DisplayStyle } from '../../Enums/UiEnums';
    import {ref} from 'vue';

    const psCard3DS2 = ref<InstanceType<typeof PaySimpleCreditCard>>();
    defineExpose({Card3DS});
    
    function Card3DS(activity_id : string,transaction_id : string) : void { 
        psCard3DS2.value?.card3DS(activity_id ,transaction_id);
    }
    const props = withDefaults(defineProps<{ 
        screenName: string,
        saveEnabled: number,
        receiptData : IReceiptData,
        bottomMargin?: CssLength
    }>(),
    { 
        bottomMargin: () => CssLength.em(0)
    });

</script>
<template>
    <PageTitle :security-screen-name="props.screenName" :bottomMargin="props.bottomMargin">
        <template #permitted>  
            <PaySimpleCreditCard ref="psCard3DS2"
                :saveEnabled="props.saveEnabled"
                :receiptData="props.receiptData">
            </PaySimpleCreditCard>  
        </template>
    </PageTitle>
    <template v-if="!props.screenName">
        <MessageSection :type="MessageSectionType.Row" :displayStyle="DisplayStyle.Danger" :showIcon="false">
            An invalid screen name has been passed, unable to perform request.
        </MessageSection>
    </template>
</template>